import { makeStyles } from '@material-ui/core';

export const useSyles = makeStyles({
  root: {
    flexGrow: '1',
  },
  container: {
    background: 'rgba(0, 0, 0, 0.08)',
    height: 'auto',
    flexDirection: 'column',
    minHeight: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    gap: '30px',
  },
  wrapper: {
    borderRadius: '15px',
    // boxShadow: '6px 2px 20px 0px',
    width: 'auto',
    minWidth: '90%',
    maxWidth: '95%',
    margin: 'auto',
    minHeight: '50%',
    background: 'white',
    padding: '40px',
    display: 'grid',
    alignContent: 'center',
    gap: '24px',
  },
  title: {
    fontSize: '2rem',
    fontWeight: 'Bold',
    color: '#1d1a20',
    padding: '30px',
    display: 'flex',
    justifyContent: 'center',
  },
  button: {
    display: 'flex',
    margin: 'auto',
    justifyContent: 'flex-end',
    padding: '8px 16px 0',
  },
});
